import React from 'react';
import Dialog from 'material-ui/Dialog';
import FontIcon from 'material-ui/FontIcon'
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';


export default class HousingPrefModal extends React.Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({open: true});
  };

  handleClose = () => {
    this.setState({open: false});
  };

  render() {
    const actions = [
      <FlatButton
        label="Close"
        primary={true}
        onTouchTap={this.handleClose}
      />
    ];

    return (
      <div className="right-float">
        <FontIcon onTouchTap={this.handleOpen} className="material-icons help_outline right-float">help</FontIcon>

        <Dialog
          title="Housing Preferences Guide"
          actions={actions}
          modal={false}
          open={this.state.open}
          onRequestClose={this.handleClose}
          autoScrollBodyContent={true}
        >
        <div className="modal-summary">
            <p>Browse, add, rank, and submit your preferences on where you want to live next year. We recommend at least 6 preferences per group.</p>
        </div>
        <p><b>My Preferences</b> - Here you can see all the information on your favorite rooms and rank them according to your preference. Remember, the more preferences you list, the likelier you are to get the housing you want. When your group is satisfied, click “submit preferences” to lock them in.</p>
        <p><b>Transfer Leadership</b> - don’t want to be the group leader anymore? Click here and we’ll work with you to assign a new group leader.</p>
        <p><b>Submit Preferences</b> - Make sure everyone in your group is satisfied with your preferences and contact your group leader if there are any disagreements. After clicking this button, your preferences will be finalized and you cannot change them.</p>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/components/modals/housing-preferences.js